<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<!-- DESIGN mode -->
@if (this.Mode === 'design') {
<div class="flex-row-top-right">
    <div class="fill-remaining-space">
        <!-- If there are instructions, display label first, then instructions then field -->
        @if (this.HasInstructions) {
        @if (this.DisplayName) {
        <div class="design-mode-field-label">
            {{this.DisplayName}} @if (this.FormField.required) {
            <span style="color: #EF0000;">*</span>
            }
        </div>
        }
        <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        }
        <mat-form-field appearance="outline">
            @if (this.ShowLabel && !HasInstructions) {
            <mat-label class="design-mode-field-label">
                {{this.DisplayName}} @if (this.FormField.required) {
                <span style="color: #EF0000;">*</span>
                }
            </mat-label>
            }
            <input matInput
                   type="date"
                   placeholder="{{this.PlaceholderText}}"
                   disabled />
        </mat-form-field>
        <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
</div>
  }

<!-- DESIGN PREVIEW or INSTANCE mode -->
  @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
<div class="flex-row-top-right">
    <div class="fill-remaining-space">
        @if (this.FormGroup !== null) {
        <!-- If there are instructions, display label first, then instructions then field -->
        @if (this.HasInstructions) {
        @if (this.DisplayName) {
        <div class="field-label">
            {{this.DisplayName}} @if (this.FormField.required) {
            <span style="color: #EF0000;">*</span>
            }
        </div>
        }
        <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        }
        <form [formGroup]="this.FormGroup">

            @if(this.fieldIsInGrid) {
            <mat-datepicker-toggle matSuffix
                                   class="datepicker-grid"
                                   [for]="picker"
                                   id="{{this.MatInputId}}"></mat-datepicker-toggle>
            <mat-datepicker #picker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                </mat-datepicker-actions>
            </mat-datepicker>
            <input matInput
                   class="date-in-grid"
                   dateFormat formatString="{{this.DatePipeFormat}}"
                   #dateInput
                   [min]="this.MinDate"
                   [max]="this.MaxDate"
                   [matDatepicker]="picker"
                   formControlName="date_control"
                   placeholder="{{this.PlaceholderText}}"
                   (blur)="this.handleOnBlur()"
                   (dateChange)="this.handleOnModelChange()" />
            }
            @else {
            <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true" subscriptSizing="dynamic">
                <!-- If there are no instructions, display label integrated into the field -->
                @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
                <mat-label class="field-label">
                    {{this.DisplayName}} @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                    }
                </mat-label>
                }
                @if (this.ReadOnly === false) {
                <ng-container>
                    <mat-datepicker-toggle matSuffix
                                           class="datepicker"
                                           [for]="picker"
                                           id="{{this.MatInputId}}"></mat-datepicker-toggle>
                    <input matInput
                           dateFormat formatString="{{this.DatePipeFormat}}"
                           #dateInput
                           [min]="this.MinDate"
                           [max]="this.MaxDate"
                           [matDatepicker]="picker"
                           formControlName="date_control"
                           class="enabled-date-input"
                           placeholder="{{this.PlaceholderText}}"
                           (blur)="this.handleOnBlur()"
                           (dateChange)="this.handleOnModelChange()" />
                    <mat-datepicker #picker>
                        <mat-datepicker-actions>
                            <button mat-button matDatepickerCancel>Cancel</button>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        </mat-datepicker-actions>
                    </mat-datepicker>
                </ng-container>
                }
                @if (this.ReadOnly === true) {
                <input matInput
                       dateFormat formatString="{{this.DatePipeFormat}}"
                       #dateInput
                       [min]="this.MinDate"
                       [max]="this.MaxDate"
                       [readonly]="true"
                       formControlName="date_control"
                       class="enabled-date-input"
                       placeholder="{{this.PlaceholderText}}" />
                <span class="formatted-date-span-no-click">{{this.FormattedDateValue}}</span>
                <!--<mat-datepicker #na_picker></mat-datepicker>-->
                <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
                }
            </mat-form-field>
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
            }
        </form>
        }
    </div>
    <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
</div>
      }
